import toast from '@/common/toast';

const errorMessage = 'Unable to authenticate with Rebilly. Please login and try again. If the issue persists please contact support.';

/**
 * Setup api jwt error handler
 * dispatch logout on api 401 - Json web token not found error.
 * @param {Object} api
 * @param {Object} store
 */
export default function jwtErrorMiddleware({api, store}) {
    api.setupJWTErrorResponseInterceptor({
        store,
        callback: ({store: injectedStore}) => {
            if (injectedStore.getters['user/isGuest']
                || injectedStore.getters['user/isSessionExpired']) {
                // ignore guest
                return;
            }
            injectedStore.dispatch('app/logout');
            setTimeout(
                () => toast.negative(
                    errorMessage,
                    {delay: 10000},
                ),
                500,
            );
        },
    });
}
